import React from 'react';
import { EnhancedHeadCell } from '@components/Table/types';
import { Box, useTheme } from '@mui/material';
import TableCell from '@mui/material/TableCell';

export default function GroupedHeadCells({ headCells }) {
  if (headCells.isMultiLevel) {
    return headCells.cells.map(v => (
      <HeadCell key={v.value} v={v} headCells={headCells}>
        <GroupedHeadCells headCells={v.cells} />
      </HeadCell>
    ));
  }

  return headCells.cells.map(v => <HeadCell v={v} headCells={headCells} />);
}

const isEnhancedCell = (cell): cell is EnhancedHeadCell => typeof cell === 'object' && 'label' in cell && 'value' in cell;

function HeadCell({
  v,
  headCells,
  children,
}: {
  v: string | number | null | undefined | EnhancedHeadCell;
  headCells: any;
  children?: React.ReactNode;
}) {
  const enhancedCell = isEnhancedCell(v) ? v : { label: v, value: v, sx: {}, isChild: true };
  const { palette } = useTheme();

  return (
    <TableCell
      key={enhancedCell.value}
      sx={{
        background: palette.colors.neutrals[150],
        borderRight: `1px solid ${palette.colors.neutrals[350]}`,
        ...(enhancedCell.isChild ? { borderBottom: 0 } : {}),
        '&.MuiTableCell-root': { padding: 0 },
        ...enhancedCell.sx,
      }}
      align="center"
      colSpan={headCells.innerCols}>
      <Box
        sx={{
          padding: '5px 12px',
          ...(headCells.isMultiLevel ? { borderBottom: `1px solid ${palette.colors.neutrals[350]}` } : {}),
        }}>
        {enhancedCell.label}
      </Box>
      {children}
    </TableCell>
  );
}
